// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://cofxjrhjcbdajmmosemn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNvZnhqcmhqY2JkYWptbW9zZW1uIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA0Mzc1MzEsImV4cCI6MjA2NjAxMzUzMX0.vmOy9g_JOfp9Asd-_dYhgfbWbb8vobnBBmTTRl3cZ8E";
// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
